/**
 * Build a user-facing message from an axios/API error response.
 */
export function getApiErrorMessage(error, fallback = 'Something went wrong. Please try again.') {
  const data = error?.response?.data;
  if (!data) {
    return error?.message || fallback;
  }

  if (Array.isArray(data.errors) && data.errors.length > 0) {
    const joined = data.errors.filter(Boolean).join('\n');
    if (joined) return joined;
  }

  if (typeof data.message === 'string' && data.message.trim()) {
    return data.message.trim();
  }

  if (typeof data.error === 'string' && data.error.trim()) {
    return data.error.trim();
  }

  return fallback;
}
